module.exports = __webpack_public_path__ + "static/professional-life-f9b9e5dff386e95bbf34e6739e076702.jpg";